import { render, staticRenderFns } from "./NsAccordionPanel.vue?vue&type=template&id=4202a6db&scoped=true&%3Aindex=index&"
import script from "./NsAccordionPanel.vue?vue&type=script&lang=js&"
export * from "./NsAccordionPanel.vue?vue&type=script&lang=js&"
import style0 from "./NsAccordionPanel.vue?vue&type=style&index=0&id=4202a6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4202a6db",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsIcon: require('/usr/app/src/components/ns/NsIcon.vue').default})
